import { EnvVariables } from "./../app/environment-variables/environment-variables.token";
import { AppFacade } from "./../facade/app.facade";
import { Injectable, Inject } from "@angular/core";

import { Events } from "ionic-angular";
import Echo from "laravel-echo";

import Pusher from "pusher-js";
import { Config } from "pusher-js/types/src/core/config";

@Injectable()
export class Realtime {
  private echo: Echo;

  constructor(
    private facade: AppFacade,
    @Inject(EnvVariables) public envVariables,
    private events: Events
  ) {}

  connect(): void {
    this.facade.auth$.subscribe((res) => {
      if (res.token) {
        const config: Partial<Config> = {
          wsHost: this.envVariables.pusherUrl,
          authEndpoint: `${this.envVariables.backendEndpoint}/broadcasting/auth`,
          auth: {
            headers: {
              Authorization: "Bearer " + res.token,
            },
          },
          enableStats: false,
          forceTLS: true,
        };

        this.echo = new Echo({
          broadcaster: "pusher",
          client: new Pusher(this.envVariables.pusherKey, config),
        });

        this.echo
          .private("UPDATE_REDUX")
          .listen(".DOCK_UPDATE", (payload) => {
            let obj = { type: "DOCK_UPDATE", payload };
            this.facade.store.dispatch(obj);
            this.events.publish("dock:updated", payload.dock);
          })
          .listen(".DOCK_STATUS_UPDATE", (payload) => {
            let obj = { type: "DOCK_STATUS_UPDATE", payload };
            this.facade.store.dispatch(obj);
            this.events.publish("dock:updated", payload.dock);
          })
          .listen(".DOCK_CLEAR_ALL", (e) => {
            window.location.reload();
          });
      }
    });
  }

  disconnect(): void {
    if (this.echo) {
      this.echo.disconnect();
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/realtime.ts